import facebookLogo from '@/images/platforms/facebook.svg';
import instagramLogo from '@/images/platforms/instagram.png';
import tiktokLogo from '@/images/platforms/tiktok.png';
import twitterLogo from '@/images/platforms/twitter.svg';
import youtubeLogo from '@/images/platforms/youtube.png';
import { INBOUND_APPLICATION_PLATFORM } from '@Saral-Influencer-Marketing/saral-utils/src/constants/inboundApplication';
import { PRODUCT_REQUEST_STATUS } from '@Saral-Influencer-Marketing/saral-utils/src/constants/productRequests';

export const INBOUND_FILTER_BY_PLATFORM_OPTIONS = [
  {
    label: 'Instagram',
    value: INBOUND_APPLICATION_PLATFORM.INSTAGRAM,
    logo: instagramLogo,
  },
  {
    label: 'TikTok',
    value: INBOUND_APPLICATION_PLATFORM.TIKTOK,
    logo: tiktokLogo,
  },
  {
    label: 'YouTube',
    value: INBOUND_APPLICATION_PLATFORM.YOUTUBE,
    logo: youtubeLogo,
  },
  {
    label: 'Facebook',
    value: INBOUND_APPLICATION_PLATFORM.FACEBOOK,
    logo: facebookLogo,
  },
  {
    label: 'X (Twitter)',
    value: INBOUND_APPLICATION_PLATFORM.TWITTER,
    logo: twitterLogo,
  },
];

export const INBOUND_FILTER_OPTIONS = {
  PLATFORM: 'platforms',
  FOLLOWERS: 'followers',
};

export const INBOUND_TABS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  INCOMPLETE: 'incomplete',
  PRODUCT_REQUESTS: 'product-requests',
};

export const PRODUCT_REQUEST_STATUS_OPTIONS = [
  {
    label: 'Pending Requests',
    value: PRODUCT_REQUEST_STATUS.PENDING,
  },
  {
    label: 'Approved Requests',
    value: PRODUCT_REQUEST_STATUS.APPROVED,
  },
  {
    label: 'Rejected Requests',
    value: PRODUCT_REQUEST_STATUS.REJECTED,
  },
];
